import PropTypes from 'prop-types';
import React, { Children, Component, Fragment } from 'react';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import { _addNotification, _addNotificationError, getSchoolGrades, groupBy } from '../../../server/util';
import moment from 'moment';
import incomeDetailsImg from './esea-info.jpg';
import { get, postWithHeaders } from '../../../server/actions';

class ESEAApplication extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            students: [],
            otherChailds: [],
            submittedStudents: [],
            selectedIndicator: '',
            date: moment().format('MM-DD-YYYY'),
            parentName: '',
            parentEmail: '',
            schoolYear: '',
            showDetails: false

        }
    }
    componentWillMount = () => {
        const schoolsList = (this.context.router.route.location.state || {}).schoolsObject || {};
        const schoolYear = (this.context.router.route.location.state || {}).schoolYear;
        const parentEmail = (this.context.router.route.location.state || {}).parentEmail;
        const students = [];
        Object.keys(schoolsList || {}).map(skey => {
            const school = schoolsList[skey];
            Object.keys(school.students || {}).map(key => {
                const list = (school.students || {})[key] || [];
                list.map(st => {
                    students.push({
                        ...st, schoolName: school.schoolName, schoolId: skey
                    });
                });
            });
        });
        this.setState({ students: students, schoolYear, parentEmail });
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.getSubmittedStudents();
    }
    onCancelApplication = (e) => {
        this.context.router.history.goBack();
    }
    getSubmittedStudents = () => {
        const { schoolYear, parentEmail, students, loading } = this.state;
        const url = `/eseaForms/submitted/studentRecIds?parentEmail=${parentEmail}&schoolYear=${schoolYear}&access_token=`;
        this.setState({ loading: true });
        get(url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({
                submittedStudents: data.resp, students: students.filter(s => {
                    return !(data.resp || []).includes(s.displayRecId)
                }), loading: false
            });
        }).catch(
            (error) => {
                console.log('Get School data response', error);
                this.setState({ loading: false })
            }
        );

    }
    submitApplication = (e) => {
        const { students, otherChailds, parentName, selectedIndicator, schoolYear, parentEmail } = this.state;
        const url = `/eseaForms?access_token=`;
        const reqBody = {
            "schoolYear": schoolYear,
            "indicator": selectedIndicator,
            "parentEmail": parentEmail,
            "parentSign": parentName,
            "date": moment().format('MM/DD/YYYY'),
            "students": []
        };
        let headers = {
            'Content-Type': 'application/json'
        };
        students.map(st => {
            reqBody.students.push(
                {
                    "firstName": st.firstName,
                    "lastName": st.lastName,
                    "grade": st.gradeName,
                    "mealSchoolId": st.mealSchoolId,
                    "studentRecId": st.displayRecId,
                    "schoolName": st.schoolName
                }
            )
        });
        otherChailds.map(ch => {
            reqBody.students.push({
                "firstName": ch.name,
                "lastName": '',
                "grade": ch.grade,
                "schoolName": ch.schoolName
            });
        })
        if ((selectedIndicator || '').trim() === '') {
            _addNotificationError('Please select Indicator.', this);
            return false;
        }
        otherChailds.map(ch => {
            if ((Object.keys(ch).length === 0 || Object.values(ch).every(value => value === ''))) {
                _addNotificationError('Please fill student details.', this);
                return false;
            }
        })
        if (( parentName||'').trim() === '') {
            _addNotificationError('Please enter Parent/Guardian name .', this);
            return false;
        }
        postWithHeaders(url, JSON.stringify(reqBody), headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            _addNotification(data.statusMessage, this);
            console.log(data);
            setTimeout(() =>
                this.context.router.history.goBack(), 2000);

        }).catch(error => {
            _addNotificationError('Unable to add request ! Try Again.', this);
        });
    }
    render() {
        const { students, otherChailds, selectedIndicator, parentName, date, loading } = this.state;
        return (
            <Fragment>
                <section className="full-width clearfix">
                    <NotificationSystem ref="notificationSystem" />
                    <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="container">
                        <div className="row " style={{ paddingBottom: '5px' }}>
                            <div className=" col-md-3 sectionTitle">
                                <h2 style={{ margin: '20px 0px 0px' }}>
                                    <span style={{ marginTop: '6px' }}>
                                        ESEA (Title I) Income Eligibility
                                    </span>
                                </h2>
                            </div>
                        </div>
                        {
                            ((students || []).length > 0 && loading == false) ? <Fragment>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <p>
                                            The Arizona Department of Education provides the following FY 2024 Income Guidelines for determining eligibility information for federal
                                            funding associated with programs funded under the Elementary and Secondary Education Act (ESEA).
                                        </p>
                                        <p><a href="javascript:void(0)" onClick={() => {
                                            this.setState({ showDetails: true })
                                        }}>Click here</a> for Income guidelines</p>
                                        {this.state.showDetails && <p style={{ width: '100%' }}>
                                            <div className='text-right'><a href="javascript:void(0)" onClick={() => {
                                                this.setState({ showDetails: false })
                                            }}><i className='fa fa-times-circle fa-lg'></i> Close</a></div>
                                            <div style={{ display: 'flex', justifyContent: 'center' }}><img src={incomeDetailsImg} style={{ width: '50vw' }} /></div>


                                        </p>}
                                        <p>
                                            Is your family at or below the current income guidelines based on the attached ESEA (Title I) Income Eligibility Guidelines schedule?
                                        </p>
                                        <p>
                                            <ul style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <li><input type="checkbox" className='chbox' checked={selectedIndicator == 'Indicator 1'} value='Indicator 1' onChange={(e) => {
                                                    if (e.target.checked) {
                                                        this.setState({ selectedIndicator: e.target.value });
                                                    }
                                                }} /> Indicator 1</li>
                                                <li><input type="checkbox" className='chbox' checked={selectedIndicator == 'Indicator 2'} value='Indicator 2' onChange={(e) => {
                                                    if (e.target.checked) {
                                                        this.setState({ selectedIndicator: e.target.value });
                                                    }
                                                }} /> Indicator 2</li>
                                                <li><input type="checkbox" className='chbox' checked={selectedIndicator == 'No'} value='No' onChange={(e) => {
                                                    if (e.target.checked) {
                                                        this.setState({ selectedIndicator: e.target.value });
                                                    }
                                                }} /> No</li>
                                            </ul>
                                        </p>
                                        <p>
                                            Definition of Income: all items such as wages and salaries before any deductions, and other income, such as self employment, welfare, social
                                            security, retirement benefits unemployment compensation, worker's compensation, Aid for Dependent Children, alimony, child support,
                                            pensions, insurance or annuity payments, etc.
                                        </p>
                                        <p>If your family qualifies, please complete the following information for each child:</p>
                                        <p>
                                            <table className='table'>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '50px' }}>S.No</th>
                                                        <th>Child's Name</th>
                                                        <th>Name of School</th>
                                                        <th>Grade</th>
                                                        <th style={{ width: '50px' }}>
                                                            <button className='btn btn-sm btn-success' style={{ margin: '0px' }} onClick={(e) => {
                                                                const _otherChailds = [...this.state.otherChailds];
                                                                _otherChailds.push({});
                                                                this.setState({ otherChailds: _otherChailds });
                                                            }} >
                                                                <i className='fa fa-plus'></i>
                                                            </button>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        (students || []).map((stud, i) => {
                                                            const gradeGroup = groupBy(getSchoolGrades(stud.mealSchoolId), 'value');
                                                            const label = ((gradeGroup[stud.gradeName] || [])[0] || {}).label;
                                                            return (<tr>
                                                                <td>{i + 1}.</td>
                                                                <td>{stud.firstName + ' ' + stud.lastName}</td>
                                                                <td>{stud.schoolName}</td>
                                                                <td>{label}</td>
                                                                <td></td>
                                                            </tr>)
                                                        })

                                                    }
                                                    {
                                                        (otherChailds || []).map((child, j) => {
                                                            return (<tr>
                                                                <td>{(students.length) + j + 1}.</td>
                                                                <td><input type='text' className='form-control' name="name" value={child.name || ''} onChange={(e) => {
                                                                    const _otherChailds = [...this.state.otherChailds];
                                                                    _otherChailds[j].name = e.target.value;
                                                                    this.setState({ otherChailds: _otherChailds });
                                                                }} /></td>
                                                                <td><input type='text' className='form-control' name="name" value={child.schoolName} onChange={(e) => {
                                                                    const _otherChailds = [...this.state.otherChailds];
                                                                    _otherChailds[j].schoolName = e.target.value;
                                                                    this.setState({ otherChailds: _otherChailds });
                                                                }} /></td>
                                                                <td><input type='text' className='form-control' name="name" value={child.grade} onChange={(e) => {
                                                                    const _otherChailds = [...this.state.otherChailds];
                                                                    _otherChailds[j].grade = e.target.value;
                                                                    this.setState({ otherChailds: _otherChailds });
                                                                }} /></td>
                                                                <td>
                                                                    <button className='btn btn-sm btn-danger' style={{ margin: '0px' }} onClick={(e) => {
                                                                        const _otherChailds = [...this.state.otherChailds];
                                                                        _otherChailds.splice(j, 1);
                                                                        this.setState({ otherChailds: _otherChailds });
                                                                    }} >
                                                                        <i className='fa fa-trash'></i>
                                                                    </button>
                                                                </td>
                                                            </tr>)
                                                        })
                                                    }

                                                </tbody>
                                            </table>
                                        </p>
                                        <p>
                                            I hereby certify that all the above information is true and correct.
                                        </p>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="parentSignature" className="col-md-2 col-form-label">Parent/Guardian</label>
                                        <div className="col-md-4">
                                            <input type="text" className="form-control" id="parentSignature"
                                                name="parenetName" placeholder="" value={parentName} onChange={(e) => {
                                                    this.setState({ parentName: e.target.value })
                                                }} />
                                        </div>
                                        <label htmlFor="date" className="col-md-1 col-md-offset-3 col-form-label">Date:</label>
                                        <div className="col-md-2">
                                            <input type="text" className="form-control" value={date} id="date" placeholder="" />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <p>These survey forms should be retained by the school or LEA and kept on file for a period of 5 years.</p>
                                        </div>
                                    </div>
                                </div>

                            </Fragment> : <div className='row'>
                                <div className='col-md-12 text-center' >
                                    <p style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '250px' }}>
                                        <span>
                                            Already Application submitted. Please contact your school administrator.</span>
                                    </p>
                                </div>
                            </div>
                        }

                        <div className='row'>
                            <div className='col-md-12 text-right'>
                                <button type="button" className='btn btn-sm btn-danger' onClick={(e) => {
                                    this.onCancelApplication(e)

                                }}>Cancel</button>
                                {
                                    (students || []).length > 0 && <button type="button" className='btn btn-sm btn-primary' onClick={(e) => {
                                        this.submitApplication(e)
                                    }}>Save</button>
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </Fragment>
        );
    }
}
ESEAApplication.contextTypes = {
    router: PropTypes.object.isRequired
}

export default ESEAApplication;


// WEBPACK FOOTER //
// ./src/components/Parent/ESEAApplication/index.js